import { Link, useSearchParams } from 'react-router-dom'
import { useLang } from '../i18n/LanguageContext'
import './HomePage.css'

function UnknownTenantNotice() {
  const [searchParams] = useSearchParams()
  const { t } = useLang()
  const reason = searchParams.get('reason')
  const host = searchParams.get('host')

  if (reason !== 'unknown-tenant') {
    return null
  }

  return (
    <div className="container" style={{ paddingTop: 'var(--space-6)' }}>
      <div className="alert alert-warning">
        {t('home.unknownTenant', { host: host || t('home.unknownTenantHere') })}{' '}
        <a href="/contact">{t('home.unknownTenantContact')}</a>.
      </div>
    </div>
  )
}

function HomePage() {
  const { t } = useLang()
  const features = t('home.features')
  const steps = t('home.steps')

  return (
    <div className="home-page">
      <UnknownTenantNotice />

      {/* Hero */}
      <section className="hero">
        <div className="container">
          <div className="hero-grid">
            <div>
              <h1 className="hero-title">
                {t('home.heroTitlePre')}{' '}
                <span className="highlight">CommunityNord</span>
              </h1>
              <p className="hero-subtitle">
                {t('home.heroSubtitle')}
              </p>
              <div className="hero-actions">
                <a href="/signup" className="btn btn-white btn-lg">
                  {t('home.ctaFree')}
                </a>
                <Link to="/features" className="btn btn-outline btn-lg" style={{borderColor: 'white', color: 'white'}}>
                  {t('home.learnMore')}
                </Link>
              </div>
            </div>
            <div className="hero-visual">
              <img
                className="hero-screenshot"
                src="/screens/admin-dashboard.png"
                alt={t('home.heroImageAlt')}
                width="1440"
                height="900"
                loading="eager"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="section features-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">{t('home.featuresTitle')}</h2>
            <p className="section-subtitle">
              {t('home.featuresSubtitle')}
            </p>
          </div>
          <div className="grid grid-3">
            {features.map((f, i) => (
              <div key={i} className="card">
                <div className="card-icon">{f.icon}</div>
                <h3 className="card-title">{f.title}</h3>
                <p className="card-text">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="section steps-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">{t('home.stepsTitle')}</h2>
          </div>
          <div className="steps-grid">
            {steps.map((s, i) => (
              <div key={i} className="step">
                <div className="step-number">{s.num}</div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta">
        <div className="container">
          <h2 className="cta-title">{t('home.ctaTitle')}</h2>
          <p className="cta-text">{t('home.ctaText')}</p>
          <a href="/signup" className="btn btn-white btn-lg">
            {t('home.ctaButton')}
          </a>
        </div>
      </section>
    </div>
  )
}

export default HomePage
